import { useMemo } from "react";

import { Issue } from "@protos/issues/v1/issues";

/**
 * Generates a human-readable name to display for the given SCA issue.
 *
 * TODO: this logic should live exclusively in the server.
 */
export function useScaHumanReadableIssueName(issue: Issue) {
  return useMemo<string | null>(() => {
    if (issue.scaAttributes === undefined) {
      return null;
    }

    const issueDependencyName = issue.scaAttributes.foundDependency?.package;
    if (
      !Array.isArray(issue.scaAttributes.cwes) ||
      issue.scaAttributes.cwes.length === 0
    ) {
      return `Vulnerability in ${issueDependencyName}`;
    }

    const firstCwe = issue.scaAttributes.cwes[0];
    let cwe = firstCwe.replace(/^CWE-\d+?: ?/, "");
    const firstCweShortName = firstCwe.match(/'(.+?)'/);
    if (firstCweShortName) {
      cwe = firstCweShortName[1];
    }

    if (firstCweShortName) {
      return `${issueDependencyName}: ${cwe}`;
    }

    return `${issueDependencyName}: ${cwe}`;
  }, [issue.scaAttributes]);
}
